var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1668_22764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.97266 19.6489V4.09813C4.97266 1.95102 6.70215 0.210449 8.8356 0.210449H14.8678C15.8774 0.210449 16.8467 0.608185 17.5684 1.3184L21.8373 5.51911L21.8719 5.55362C22.5937 6.28195 22.9997 7.26908 22.9997 8.29891V19.6489C22.9997 21.796 21.2702 23.5365 19.1367 23.5365H8.8356C6.70217 23.5365 4.97266 21.796 4.97266 19.6489ZM12.0547 6.68989C12.0547 5.9742 12.6312 5.39402 13.3423 5.39401C14.0535 5.39401 14.63 5.9742 14.63 6.68989V10.5776H16.5615C17.2726 10.5776 17.8491 11.1578 17.8491 11.8735C17.8491 12.5892 17.2726 13.1694 16.5615 13.1694H13.3423C12.6312 13.1694 12.0547 12.5892 12.0547 11.8735V6.68989ZM7.54792 19.6489C7.54793 20.3646 8.12444 20.9447 8.8356 20.9447H19.1367C19.8479 20.9447 20.4244 20.3646 20.4244 19.6489V8.29891C20.4244 7.96104 20.2934 7.63704 20.0599 7.39552L20.0369 7.37236L15.768 3.17154C15.5274 2.93475 15.2043 2.80221 14.8678 2.80221H8.8356C8.12445 2.80221 7.54792 3.38243 7.54792 4.09813V19.6489Z",
    fill: "#06362B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.686V10.4085C0 8.25799 1.66986 6.51465 3.72974 6.51465H6.2162C6.90283 6.51465 7.45947 7.09575 7.45947 7.81259C7.45947 8.52943 6.90283 9.11053 6.2162 9.11053H3.72974C3.04311 9.11053 2.48647 9.69167 2.48647 10.4085V24.686C2.48647 25.4029 3.0431 25.984 3.72974 25.984H13.6757C14.3623 25.984 14.9189 25.4029 14.9189 24.686V22.0901C14.9189 21.3733 15.4755 20.7921 16.1622 20.7921C16.8488 20.7921 17.4054 21.3733 17.4054 22.0901V24.686C17.4054 26.8366 15.7356 28.5799 13.6757 28.5799H3.72974C1.66987 28.5799 0 26.8366 0 24.686Z",
    fill: "#06362B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1668_22764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDraft);
export default __webpack_public_path__ + "static/media/ic_draft.b37567a502fc5861c1817426aaf194ba.svg";
export { ForwardRef as ReactComponent };